/* eslint-disable react/prop-types */
import React from "react";
import Error from "../../images/Error.svg";
import { ErrorDisplay } from "./ErrorDisplay";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can log errors to an external service here
    console.error("ErrorBoundary caught:", error, errorInfo);
    this.setState({ error });
  }

  render() {
    if (this.state.hasError) {
      const errMessage = this.state.error?.toString() || "Unknown error";
      return (
        <ErrorDisplay
          errorSvg={<Error className="w-40 h-40 mx-auto" />}
          errorTitle="Something Went Wrong!"
          errorContent="We're experiencing a temporary issue. Please try again in a moment."
          viewErrDetails={errMessage}
          btnToHome
        />
      );
    }

    return this.props.children;
  }
}

export { ErrorBoundary };
